import api from '../api';

/**
 * Extrai URL HTTP do player a partir de string ou objeto da API.
 * @param {unknown} value
 * @returns {string}
 */
export function normalizePlayerUrl(value) {
    if (typeof value === 'string') {
        const trimmed = value.trim();
        if (/^https?:\/\//i.test(trimmed)) {
            return trimmed;
        }
        if (trimmed.startsWith('{') && trimmed.endsWith('}')) {
            try {
                return normalizePlayerUrl(JSON.parse(trimmed));
            } catch {
                return '';
            }
        }
        return '';
    }
    if (value && typeof value === 'object') {
        const candidates = [
            value.url,
            value.embed,
            value.embedUrl,
            value.player,
            value.path,
            value.src,
        ];
        for (const candidate of candidates) {
            if (typeof candidate === 'string' && /^https?:\/\//i.test(candidate.trim())) {
                return candidate.trim();
            }
        }
    }
    return '';
}

function authHeaders(accessToken) {
    return {
        Authorization: `Bearer ${accessToken}`,
    };
}

export default {
    normalizePlayerUrl,

    /**
     * Player do aluno no curso.
     * GET /portal/videoteca/player/{id} — Bearer; {id} = lesson criptografado.
     */
    async getPlayerVideo(accessToken, id) {
        try {
            const response = await api.get(`/portal/videoteca/player/${id}`, {
                headers: authHeaders(accessToken),
            });
            return normalizePlayerUrl(response.data);
        } catch (error) {
            console.error('Erro ao obter o player:', error);
            throw error;
        }
    },
};
